import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'date', sortDesc = false, fetchFacets = true) {

    return Api().post('/warrants/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  documents() {
    return Api().get('/warrants/documents');
  },
  print_md(data) {
    return Api().get('/warrants/md-PDF/' + data.dsmId + '?doEntete=' + data.doEntete);
  },
  print_dossier_nego(data) {
    return Api().post('/warrants/dossier-nego-PDF', 'ways=' + encodeURIComponent(JSON.stringify(data.ways)));
  },
  settlementsPDF(data) {
    return Api().get('/warrants/settlements-PDF/' + data.type);
  },
  confirm_reminders(data) {
    return Api().get('/warrants/confirm-reminders/' + data.type + '/' + data.envoi);
  },
  confirm_courriers(data) {
    return Api().get('/warrants/confirm-courriers/' + data.dsmId);
  },
  cleanWarrant(id) {
    return Api().post('/warrant/' + id + '/clean');
  },
  open(id, data) {
    return Api().post('/warrant/' + id + '/open', qs.stringify({ data: JSON.stringify(data) }));
  },
  get(id) {
    return Api().get('/warrant/' + id);
  },
  
  get_warrants_stop() {
    return Api().get('/warrants-stop');
  },
  send_acks() {
    return Api().post('/warrants/send-acks')
  },
  cloturePdf(id, date, body) {
    return Api().post('/warrant/' + id + '/stop/pdf', qs.stringify({
      date, body
    }));
  },
  clotureBody(id, date, reasons) {
    return Api().post('/warrant/' + id + '/stop/body', qs.stringify({
      date, reasons: JSON.stringify(reasons)
    }));
  },
  cancel_warrant(data) {
    return Api().delete('/warrant/' + data.id + '/cancel');
  },
  update(id, data, recompute, sync, send_mail_cloture, field) {
    return Api().post('/warrant/' + id, qs.stringify({ data: JSON.stringify(data), recompute, sync, send_mail_cloture, field }));
  },
  invoices(id) {
    return Api().get('/warrant/' + id + '/invoices')
  },
  delete_courrier(data) {
    return Api().delete('/courrier/' + data.id);
  },
  delete_invoice(data) {
    return Api().delete('/warrant/' + data.warrant_id + '/invoice/' + data.invoice_id);
  },
  update_invoice(data) {
    return Api().post('/warrant/' + data.warrant_id + '/invoice/' + data.invoice_id, qs.stringify({ data: JSON.stringify(data.invoice) }));
  },
  create_invoice(data) {
    return Api().post('/warrant/' + data.warrant_id + '/invoice', qs.stringify({ data: JSON.stringify(data.invoice) }));
  },
  invoice(data) {
    return Api().get('/warrant/' + data.warrant_id + '/invoice/' + data.invoice_id);
  },
  indemnities(id) {
    return Api().get('/warrant/' + id + '/indemnities')
  },
  delete_indemnity(data) {
    return Api().delete('/warrant/' + data.warrant_id + '/indemnity/' + data.indemnity_id);
  },
  update_indemnity(data) {
    return Api().post('/warrant/' + data.warrant_id + '/indemnity/' + data.indemnity_id, qs.stringify({ data: JSON.stringify(data.indemnity) }));
  },
  create_indemnity(data) {
    return Api().post('/warrant/' + data.warrant_id + '/indemnity', qs.stringify({ data: JSON.stringify(data.indemnity) }));
  },
  indemnity(data) {
    return Api().get('/warrant/' + data.warrant_id + '/indemnity/' + data.indemnity_id);
  },
  delete_note(data) {
    return Api().delete('/warrant/' + data.warrant_id + '/note/' + data.note_id);
  },
  read_notes(data) {
    return Api().get('/warrant/' + data.warrant_id + '/read-notes');
  },
  update_note(data) {
    return Api().post('/warrant/' + data.warrant_id + '/note/' + data.note_id, qs.stringify({ data: JSON.stringify(data.note) }));
  },
  create_note(data) {
    return Api().post('/warrant/' + data.warrant_id + '/note', qs.stringify({ data: JSON.stringify(data.note) }));
  },
  note(data) {
    return Api().get('/warrant/' + data.warrant_id + '/note/' + data.note_id);
  },
  unread_notes() {
    return Api().get('/warrants/unread-notes');
  },
  updateIndemnities(id) {
    return Api().get('/warrant/' + id + '/update-indemnities')
  },
  summary(id) {
    return Api().get('/warrant/' + id + '/summary')
  },
  evolution(id) {
    return Api().get('/warrant/' + id + '/evolution');
  },
  save_route(data) {
    return Api().post(
      "/warrants/route",
      qs.stringify({
        data: JSON.stringify(data)
      })
    );
  },
  routes(data) {
    return Api().post('/warrants/routes', qs.stringify({
      'mandats': JSON.stringify(data.ids), 'nego': data.nego
    }));
  }
}